import React from 'react';
import { useSteps } from '@workday/upc-common';
import { TOTPVerificationForm } from '../../../../shared/totpVerificationForm/TOTPVerificationForm';
import { ChangePasswordEntry } from './change-password-entry';
import { useVerifyTotpMutation } from '../../../../slices/account-api.slice';

export function ChangePasswordSteps({ onClose }) {
    const { next, currentStep } = useSteps();

    const [verifyTotp, verifyTotpMutation] = useVerifyTotpMutation();

    function onSubmit(payload) {
        verifyTotp({
            passcode: payload.passcode,
            operation: 'change-password'
        });
    }

    return currentStep === 0 ? (
        <TOTPVerificationForm mutation={verifyTotpMutation} onSubmit={onSubmit} onNext={next} onCancel={onClose} />
    ) : currentStep === 1 ? (
        <ChangePasswordEntry onClose={onClose} />
    ) : null;
}
